<div class="layout-topbar">
    <div class="layout-topbar-row">
        <div class="layout-topbar-logo-container">
            <a class="layout-topbar-logo" [routerLink]="'/dashboard'">
                <img class="logo-erpa" src="../../../assets/images/logo.png" alt="logo" />
                <span class="applicationName">Test Accelerator</span>
            </a>
        </div>
        
        <!-- Desktop Menu -->
        <div class="menu-container desktop-menu">
            <nav class="main-navigation">
                <div *ngFor="let item of menuItems" class="nav-item-container" [class.capture-route]="isOnCaptureRoute">
                    <a [routerLink]="item.routerLink"
                       routerLinkActive="active-menu-item"
                       class="nav-link"
                       [class.has-submenu]="item.items && item.items.length > 0"
                       (click)="item.routerLink && navigateToSection(item.routerLink)">
                        <i [ngClass]="item.icon" *ngIf="item.icon"></i>
                        <span>{{ item.label }}</span>
                        <i class="pi pi-angle-down submenu-icon" *ngIf="item.items && item.items.length > 0"></i>
                    </a>
                    <div class="submenu" *ngIf="item.items && item.items.length > 0">
                        <div *ngFor="let subItem of item.items" class="submenu-item-container">
                            <a [routerLink]="subItem.routerLink"
                               routerLinkActive="active-menu-item"
                               class="nav-link submenu-link"
                               [class.has-nested-submenu]="subItem.items && subItem.items.length > 0"
                               (click)="subItem.routerLink && navigateToSection(subItem.routerLink!)">
                                <i [ngClass]="subItem.icon" *ngIf="subItem.icon"></i>
                                <span>{{ subItem.label }}</span>
                                <i class="pi pi-angle-right nested-submenu-icon" *ngIf="subItem.items && subItem.items.length > 0"></i>
                            </a>
                            <!-- Nested submenu (3rd level) -->
                            <div class="nested-submenu" *ngIf="subItem.items && subItem.items.length > 0">
                                <a *ngFor="let nestedItem of subItem.items"
                                   [routerLink]="nestedItem.routerLink"
                                   routerLinkActive="active-menu-item"
                                   class="nav-link nested-submenu-link"
                                   (click)="navigateToSection(nestedItem.routerLink!)">
                                    <i [ngClass]="nestedItem.icon" *ngIf="nestedItem.icon"></i>
                                    <span>{{ nestedItem.label }}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
        
        <div class="layout-topbar-actions profilename">
            <button type="button" class="layout-topbar-action" (click)="notificationPanel.toggle($event)">
                <i class="pi pi-bell"></i>
                <div *ngIf="unreadCount > 0" class="notification-badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</div>
            </button>
            <button type="button" class="layout-topbar-action" (click)="userPanel.toggle($event)">
                <i class="pi pi-user"></i>
            </button>
            <span class="layout-topbar-action">
                {{ userDetails?.fullName || 'John Doe' }}
            </span>
            <button type="button" class="layout-topbar-action" (click)="logout()">
                <i class="pi pi-power-off"></i>
            </button>
        </div>
    </div>

    <!-- Mobile Menu - Separate row on very small screens -->
    <div class="items-center mobile-menu">
        <p-menubar [model]="menuItems" class="custom-menubar"></p-menubar>
    </div>
</div>

<p-popover #userPanel [dismissable]="true">
    <div class="p-3">
        <p><strong>{{ userDetails?.fullName || 'John Doe' }}</strong></p>
        <p>{{ userDetails?.email || 'johndoe@erpa.com' }}</p>
    </div>
</p-popover>

<p-popover #notificationPanel class="notification-panel" [dismissable]="true">
    <div class="notification-container">
        <div class="notification-header">
            <strong>Notifications</strong>
            <span *ngIf="unreadCount > 0" class="notification-header-badge">{{ unreadCount }}</span>
        </div>
        <div class="notification-sub-container">
            <div *ngFor="let notification of notifications.slice(0, 10)" class="notification-item"
                [ngClass]="{ 'unread': !notification.isRead }">
                <div class="notification-icon-wrapper">
                    <i class="pi pi-check-circle notification-icon success"></i>
                </div>
                <div class="notification-body-content">
                    <div class="notification-header-row">
                        <span [ngClass]="notification.isRead ? 'notification-title' : 'notification-title-unread'">{{ notification.templateName }}</span>
                        <span class="notification-time">{{ notification.time }}</span>
                    </div>
                    <div class="notification-content">
                        <span class="notification-desc">{{ notification.templateContent }}</span>
                    </div>
                    <a class="notification-read-more-link" [ngClass]="{ 'unread': !notification.isRead }"
                        (click)="readMore(notification, notificationPanel)">View Results →</a>
                </div>
            </div>
            <div *ngIf="notifications.length === 0" class="notification-empty">
                <i class="pi pi-inbox"></i>
                <span>No notifications yet</span>
            </div>
        </div>
    </div>
    <div *ngIf="notifications.length > 0" class="notification-footer">
        <button pButton class="p-button-text p-button-sm"
            (click)="navigateToAllNotifications(notificationPanel)">View All Notifications</button>
    </div>
</p-popover>